// header 頭像按鈕

import UserAvatar from '@/components/user/UserAvatar'; // 頭像、頭像框

const HeaderAvatarButton = ({ onClickAvatar, avatar, avatarFrame }) => {
    return (
        <button
            onClick={onClickAvatar}
            className="cp relative w-[32px] aspect-[1] rounded-[50%] center-center border-1 border-purple1 trans group ulg:hidden"
        >
            {/* 頭像 */}
            <UserAvatar style="w-full h-full" avatar={avatar} avatarFrame={avatarFrame} />
        </button>
    );
};

export default HeaderAvatarButton;
